// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"UyyR9PK-zVXI2inX-URaJ","logo":"_14L0vlC-PJ3eTEDS8wmJHU","wrapperModal":"_192BlnpNWUu_dVf-eglj3j"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/UserAuthenticationPage/UserAuthenticationPage.scss
// module id = 797
// module chunks = 0